import React, {useState} from "react";
import BtcWrap from "../../Forexs/BtcWrap/BtcWrap";
import Chart from "../../../GlobalComponents/Chart/Chart";
import PostContent from "../../Forexs/PostContent/PostContent";

const PortalBottom = () => {
  return (
    <div>
      <button className="h-[40px]   bg-main-green text-res-sm text-main-black w-full font-semibold">
        Preview
      </button>
      <div className="mt-[56px]">
        <div className="flex flex-col lg:flex-row gap-[18px] mb-[80px]">
          <div className="md:min-w-[510px]">
            <BtcWrap></BtcWrap>
          </div>
          <div className="grow h-full">
            {/* <img src={chart} alt="" /> */}
            <Chart className="h-[521px]"></Chart>
          </div>
        </div>
        <PostContent className="!gap-[20px]"></PostContent>
      </div>
    </div>
  );
};

export default PortalBottom;
